import { apiService } from './api';
import { ENDPOINTS } from '../config/api';

// Types matching the admin-api DTOs (TradingClosureDTO / TradingClosureRequest).

export type TradingClosureScope = 'GLOBAL' | 'SPORT' | 'COMPETITION';

export interface TradingClosure {
  scope: TradingClosureScope;
  scopeId: number | null; // sport or competition id; null for a global closure
  source?: string;
  reason?: string;
  closedAt: string;
}

const SOURCE = 'admin-ui';

export const tradingClosureService = {
  listClosures: (): Promise<TradingClosure[]> => {
    return apiService.get<TradingClosure[]>(ENDPOINTS.TRADING_CLOSURES);
  },

  // No sport ids closes every sport.
  close: (sportIds: number[] | null, reason?: string): Promise<void> => {
    return apiService.postNoContent(ENDPOINTS.CLOSE_TRADING, { sportIds, reason, source: SOURCE });
  },

  // No sport ids lifts the global closure and every sport closure.
  recover: (sportIds: number[] | null): Promise<void> => {
    return apiService.postNoContent(ENDPOINTS.RECOVER_TRADING, { sportIds, source: SOURCE });
  },
};
